export default __webpack_public_path__ + "static/media/CareCarImg.bcc6b973.png";